"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('slide', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(4.000000, 5.000000)",
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("rect", {
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero",
    x: "3",
    y: "0.5",
    width: "34",
    height: "28"
  }), _react.default.createElement("polyline", {
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    points: "12 36.5 20 28.5 28 36.5"
  }), _react.default.createElement("polyline", {
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    transform: "translate(19.950550, 14.097000) rotate(-135.000000) translate(-19.950550, -14.097000) ",
    points: "23.1048003 3.07144261 23.009533 10.9557885 16.7962996 11.0244674 16.8108301 25.1225569"
  }), _react.default.createElement("path", {
    d: "M0,0.5 L40,0.5",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap
  })))));
});

exports.default = _default;